var _rect, _rect2, _path, _rect3, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragLargeVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 44,
    viewBox: "0 0 364 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 363,
    height: 43,
    rx: 5.5,
    fill: "#F0F5F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 363,
    height: 43,
    rx: 5.5,
    stroke: "#203662",
    strokeDasharray: "5 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.4 26H190.6C190.918 26 191.223 25.8736 191.449 25.6485C191.674 25.4235 191.8 25.1183 191.8 24.8V15.2C191.8 14.8817 191.674 14.5765 191.449 14.3515C191.223 14.1264 190.918 14 190.6 14H180.4C180.082 14 179.777 14.1264 179.551 14.3515C179.326 14.5765 179.2 14.8817 179.2 15.2V17.636L175.948 15.314C175.858 15.2502 175.753 15.2123 175.643 15.2043C175.534 15.1964 175.424 15.2187 175.326 15.2688C175.228 15.319 175.146 15.3951 175.089 15.4887C175.031 15.5824 175.001 15.6901 175 15.8V24.2C175.001 24.3099 175.031 24.4176 175.089 24.5113C175.146 24.6049 175.228 24.681 175.326 24.7312C175.424 24.7813 175.534 24.8036 175.643 24.7957C175.753 24.7877 175.858 24.7498 175.948 24.686L179.2 22.364V24.8C179.2 25.1183 179.326 25.4235 179.551 25.6485C179.777 25.8736 180.082 26 180.4 26ZM190.6 15.2V24.8H180.4V21.2C180.399 21.0901 180.369 20.9824 180.311 20.8887C180.254 20.7951 180.172 20.719 180.074 20.6688C179.976 20.6187 179.866 20.5964 179.757 20.6043C179.647 20.6123 179.542 20.6502 179.452 20.714L176.2 23.036V16.964L179.452 19.286C179.542 19.3498 179.647 19.3877 179.757 19.3957C179.866 19.4036 179.976 19.3813 180.074 19.3312C180.172 19.281 180.254 19.2049 180.311 19.1113C180.369 19.0176 180.399 18.9099 180.4 18.8V15.2H190.6Z",
    fill: "#203662"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "translate(185 19)",
    fill: "#F3F6F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.923 21.8457V23.0765H189.101L193.154 27.1294L192.284 27.9995L188.231 23.9466V26.7688H187V21.8457H191.923Z",
    fill: "#203662"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragLargeVideo);
export default __webpack_public_path__ + "static/media/Drag_large_Video.cfd85905f732b391d1526046e6be0111.svg";
export { ForwardRef as ReactComponent };